module.exports = __webpack_public_path__ + "static/media/Ella_C@3x.8695c26e.jpg";